<template>
  <div class="bg-white py-[32px] px-[24px]">
    <div class="flex items-center gap-[10px] mb-[24px]">
      <!-- Custom mode: router-link -->
      <router-link
        v-if="customMode"
        :to="customLink"
        class="rounded-lg button-primary w-[40px] h-[40px] inline-block flex items-center justify-center hover:text-white"
      >
        <span
          class="k-arrow-left-2 font-bold text-10 pt-[3px] align-middle mx-[5px]"
        />
      </router-link>

      <!-- Default mode: back button -->
      <button
        v-else
        class="rounded-lg button-primary w-[40px] h-[40px] inline-block"
        @click="$router.go(-1)"
      >
        <span
          class="k-arrow-left-2 h-100 font-bold text-10 pt-[3px] align-middle mx-[5px]"
        />
      </button>
      <slot
        name="header"
        :data="title"
      >
        <div class="flex items-center gap-[10px] flex-wrap">
          <h3 class="text-[#222222] font-semibold inline-block mb-0 text-[24px]">
            {{ title }}</h3>

          <slot name="header-right" />
        </div>
      </slot>
    </div>
    <slot />
  </div>
</template>

<script>
/**
 * @component LayoutWithBackBtn
 * @description A layout component with a back button and title.
 * Used for pages that need navigation back to the previous page.
 * or to a specific page.
 *
 * @prop {String} title - The title of the page.
 * @prop {Boolean} customMode - Whether to use custom mode or not.
 * @prop {String, Object} customLink - The link to navigate back to.
 */
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    customMode: {
      type: Boolean,
      default: false,
    },
    customLink: {
      type: [String, Object],
      default: '/',
    },
  },
}
</script>
